import { render, staticRenderFns } from "./LanguagesPanel.vue?vue&type=template&id=6d6b23f6&scoped=true&"
import script from "./LanguagesPanel.vue?vue&type=script&lang=js&"
export * from "./LanguagesPanel.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesPanel.vue?vue&type=style&index=0&id=6d6b23f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b23f6",
  null
  
)

export default component.exports